<template>
  <section class="section9-container content-container">
    <div class="pc-content section-content">
      <a href="https://genify.xyz" target="_blank" style="display:block">
        <div class="title-wrapper">
          <h1>{{ $t('home.s9.title') }}</h1>
        </div>
        <div class="scroll-cont">
          <vue-seamless-scroll key="scrollA" :data="imgList" :class-option="classOption" class="wrap" style="margin:60px 0 30px">
            <ul class="ul-item">
              <li v-for="(item, index) in imgList" :key="index" class="li-item">
                <img :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll key="scrollB" :data="imgList" :class-option="classOptionB" class="wrap">
            <ul class="ul-item">
              <li v-for="(item, index) in imgList" :key="index + 'a'" class="li-item">
                <img :src="item.src">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </a>
    </div>
    
    <div class="mobile-content section-content">
      <a href="https://genify.xyz" target="_blank" style="display:block">
        <div class="title-wrapper">
          <h1>{{ $t('home.s9.title') }}</h1>
        </div>
        <div class="scroll-cont">
          <vue-seamless-scroll key="scrollA" :data="imgList" :class-option="classOption" class="wrap" style="margin:40px 0 20px">
            <ul class="ul-item">
              <li v-for="(item, index) in imgList" :key="index" class="li-item">
                <img :src="item.src" width="50">
              </li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll key="scrollB" :data="imgList" :class-option="classOptionB" class="wrap">
            <ul class="ul-item">
              <li v-for="(item, index) in imgList" :key="index + 'a'" class="li-item">
                <img :src="item.src" width="50">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </a>
    </div>
  </section>
</template>
    
    <script>
    import vueSeamlessScroll from 'vue-seamless-scroll';

    export default {
      components: {
        vueSeamlessScroll
      },

      data: () => ({
        classOption: {
          direction: 3,
          step: 0.7
        },
        classOptionB: {
          direction: 2,
          step: 0.7
        },
        imgList: [
            {
                id: 1,
                src: require('../../../assets/home/ecosystem1.png')
            },
            {
                id: 2,
                src: require('../../../assets/home/ecosystem2.png')
            },
            {
                id: 3,
                src: require('../../../assets/home/ecosystem3.png')
            },
            {
                id: 4,
                src: require('../../../assets/home/ecosystem4.png')
            },
            {
                id: 5,
                src: require('../../../assets/home/ecosystem5.png')
            },
            {
                id: 6,
                src: require('../../../assets/home/ecosystem6.png')
            },
            {
                id: 7,
                src: require('../../../assets/home/ecosystem7.png')
            },
            {
                id: 8,
                src: require('../../../assets/home/ecosystem8.png')
            },
            {
                id: 9,
                src: require('../../../assets/home/ecosystem9.png')
            },
            {
                id: 10,
                src: require('../../../assets/home/ecosystem10.png')
            },
            {
                id: 11,
                src: require('../../../assets/home/ecosystem11.png')
            },
            {
                id: 12,
                src: require('../../../assets/home/ecosystem12.png')
            },
            {
                id: 13,
                src: require('../../../assets/home/ecosystem13.png')
            },
            {
                id: 14,
                src: require('../../../assets/home/ecosystem14.png')
            },
            {
                id: 15,
                src: require('../../../assets/home/ecosystem15.png')
            },
            {
                id: 16,
                src: require('../../../assets/home/ecosystem16.png')
            },
            {
                id: 17,
                src: require('../../../assets/home/ecosystem17.png')
            },
            {
                id: 1,
                src: require('../../../assets/home/ecosystem1.png')
            },
            {
                id: 2,
                src: require('../../../assets/home/ecosystem2.png')
            },
            {
                id: 3,
                src: require('../../../assets/home/ecosystem3.png')
            },
            {
                id: 4,
                src: require('../../../assets/home/ecosystem4.png')
            },
            {
                id: 5,
                src: require('../../../assets/home/ecosystem5.png')
            },
            {
                id: 6,
                src: require('../../../assets/home/ecosystem6.png')
            },
            {
                id: 7,
                src: require('../../../assets/home/ecosystem7.png')
            },
            {
                id: 8,
                src: require('../../../assets/home/ecosystem8.png')
            },
            {
                id: 9,
                src: require('../../../assets/home/ecosystem9.png')
            },
            {
                id: 10,
                src: require('../../../assets/home/ecosystem10.png')
            },
            {
                id: 11,
                src: require('../../../assets/home/ecosystem11.png')
            },
            {
                id: 12,
                src: require('../../../assets/home/ecosystem12.png')
            },
            {
                id: 13,
                src: require('../../../assets/home/ecosystem13.png')
            },
            {
                id: 14,
                src: require('../../../assets/home/ecosystem14.png')
            },
            {
                id: 15,
                src: require('../../../assets/home/ecosystem15.png')
            },
            {
                id: 16,
                src: require('../../../assets/home/ecosystem16.png')
            },
            {
                id: 17,
                src: require('../../../assets/home/ecosystem17.png')
            },
            {
                id: 1,
                src: require('../../../assets/home/ecosystem1.png')
            },
            {
                id: 2,
                src: require('../../../assets/home/ecosystem2.png')
            },
            {
                id: 3,
                src: require('../../../assets/home/ecosystem3.png')
            },
            {
                id: 4,
                src: require('../../../assets/home/ecosystem4.png')
            },
            {
                id: 5,
                src: require('../../../assets/home/ecosystem5.png')
            },
            {
                id: 6,
                src: require('../../../assets/home/ecosystem6.png')
            },
            {
                id: 7,
                src: require('../../../assets/home/ecosystem7.png')
            },
            {
                id: 8,
                src: require('../../../assets/home/ecosystem8.png')
            },
            {
                id: 9,
                src: require('../../../assets/home/ecosystem9.png')
            },
            {
                id: 10,
                src: require('../../../assets/home/ecosystem10.png')
            },
            {
                id: 11,
                src: require('../../../assets/home/ecosystem11.png')
            },
            {
                id: 12,
                src: require('../../../assets/home/ecosystem12.png')
            },
            {
                id: 13,
                src: require('../../../assets/home/ecosystem13.png')
            },
            {
                id: 14,
                src: require('../../../assets/home/ecosystem14.png')
            },
            {
                id: 15,
                src: require('../../../assets/home/ecosystem15.png')
            },
            {
                id: 16,
                src: require('../../../assets/home/ecosystem16.png')
            },
            {
                id: 17,
                src: require('../../../assets/home/ecosystem17.png')
            }
        ]
      })
    };
    </script>
    
    <style lang="less" scoped>
    .section9-container {
      margin-top: 80px;
    }

    .wrap {
        width: 100%;
        height: 72px;
        overflow: hidden;
        ul {
            display: flex;
            list-style: none;
            margin-bottom: 0;
            li {
                margin-right: 26px;
            }
        }
    }

    .wrap:first {
        ul {
            margin-bottom: 30px;
        }
    }

    .scroll-cont {
        position: relative;
    }

    .scroll-cont::before, .scroll-cont::after {
        content: '';
        display: block;
        position: absolute;
        width: 74px;
        height: 100%;
        top: 0;
        background: linear-gradient(86.07deg, #FFFFFF 43.82%, rgba(255, 255, 255, 0) 103.69%);
        z-index: 1;
    }

    .scroll-cont::before {
        left: 0;
    }

    .scroll-cont::after {
        right: 0;
        transform: rotate(-180deg);
    }
  
  
    @media (max-width: 500px) {
      .pc-content {
        display: none;
      }
      .mobile-content {
        display: block;
        .title-wrapper {
          margin-bottom: 20px;
          h1 {
            text-align: center;
            font-size: 18px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 600;
            color: rgba(38, 38, 38, 1);
            line-height: 25px;
          }
          h2 {
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 22px;
          }

          .color-text {
            font-size: 42px;
            text-align: center;
          }
        }

        .wrap {
            height: 52px;
            overflow: hidden;
            ul {
                li {
                    margin-right: 16px;
                }
            }
        }

        .wrap:first {
            ul {
                margin-bottom: 20px;
            }
        }

        .scroll-cont::before, .scroll-cont::after {
            width: 50px;
            height: 100%;
            top: 0;
            background: linear-gradient(86.07deg, #FFFFFF 43.82%, rgba(255, 255, 255, 0) 103.69%);
            z-index: 1;
        }
      }
    }
    
    @media (min-width: 501px) {
      .pc-content {
        display: block;
        .title-wrapper {
          h1 {
            font-size: 34px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            color: rgba(38, 38, 38, 1);
            line-height: 48px;
          }
          h2 {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 28px;
          }
        }
      }
      .mobile-content {
        display: none;
      }
    }
    </style>
    